const ITEMS = [
  "Performance Marketing",
  "SEO",
  "Marketplace Growth",
  "Meta Ads",
  "Google Ads",
  "Shopee Ads",
  "TikTok Ads",
  "Marketing Automation",
  "CRO",
  "Analytics & Reporting",
];

// Editorial ticker — oversized italic serif, separated by accent dots.
function Row({ hidden }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-[clamp(1.9rem,4.2vw,4rem)] font-light italic tracking-tight text-bone">
            {item}
          </span>
          <span className="h-2 w-2 shrink-0 bg-vermilion" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section data-testid="skills-marquee" className="relative overflow-hidden border-y border-hairline bg-surface py-8 sm:py-10">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </section>
  );
}
